import React from "react";
import { playground_icon } from "../../Constants/Data";
import { Link } from "react-router-dom";

function MatchCard({
  title,
  match_day,
  match_date,
  match_time,
  status,
  teams,
  result,
  playground,
  statusClassName,
  viewMatchSummaryClassName,
  handleClick,
  match_type,
}) {
  const isHidden = status === "Upcoming" || status === "Cancelled";

  const formatTime = (timeString, timeZone) => {
    if (!timeString) return "";
    const [hours, minutes] = timeString.split(":").map(Number);
    const date = new Date();
    date.setHours(hours, minutes);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      timeZone,
      hour12: false,
    });
  };

  const istTime = formatTime(match_time, "Asia/Kolkata");
  const gmtTime = formatTime(match_time, "GMT");

  let summaryText;
  switch (status) {
    case "Upcoming":
      summaryText = `MATCH BEGINS AT ${istTime} IST (${gmtTime} GMT)`;
      break;
    case "Cancelled":
      summaryText = "CANCELLED";
      break;
    default:
      summaryText = "VIEW MATCH SUMMARY";
      break;
  }

  const apiUrl = process.env.REACT_APP_API_URL;
  const imagePath = "/storage/team1_logo/";
  const imagePath1 = "/storage/team2_logo/";

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const cardContent = (
    <div className="w-full">
      <div
        className={[
          "w-full h-[340px] bg-white rounded-t-[16px]",
          "border border-[#e9e9e9]",
          "shadow-md hover:shadow-xl transition-all duration-300",
          "px-[18px] pt-[18px] pb-[14px]",
          "flex flex-col justify-between font-Rubik",
          status === "Live" ? "ring-1 ring-[#B82222]/30" : "",
        ].join(" ")}
      >
        {/* Top */}
        <div className="flex items-start justify-between gap-3">
          <div className="flex flex-col gap-1 min-w-0">
            <h3 className="text-[#4D4D4D] font-semibold text-[14px] tracking-[0.8px] uppercase">
              {title}
            </h3>

            {status !== "Live" && (
              <div className="flex flex-wrap gap-x-2 gap-y-1 text-[#2F2F2F] text-[13px]">
                <span className="whitespace-nowrap">{match_day},</span>
                <span className="whitespace-nowrap">{formatDate(match_date)}</span>
                {match_time ? <span className="text-[#3A225D] font-medium">{match_time}</span> : null}
              </div>
            )}
          </div>

          {/* Status pill */}
          {/* <div
            className={[
              "shrink-0 px-3 py-1 rounded-full text-[12px] font-semibold uppercase",
              statusClassName || "bg-[#f2f2f2] text-[#333]",
            ].join(" ")}
          >
            <div className="flex items-center gap-2">
              {status === "Live" ? <span className="h-2 w-2 rounded-full bg-[#B82222] animate-pulse" /> : null}
              <span>{status}</span>
            </div>
          </div> */}
        </div>

        {/* Result */}
        {!isHidden ? (
          <h2 className="text-[#232020] text-center text-[14px] font-medium line-clamp-2 px-2">
            {result}
          </h2>
        ) : (
          <div />
        )}

        {/* Teams Box */}
        {/* Teams Box (FIXED ORDER + FIXED LOGO/VS SIZE) */}
        <div className="bg-[#FFFFFF] rounded-[14px] border border-[#00000010] px-[8px] py-[10px] md:px-[14px] md:py-[14px]">
          <div className="grid grid-cols-[1fr_auto_auto_auto_1fr] md:grid-cols-[1fr_84px_46px_84px_1fr] items-center gap-1 md:gap-3">
            {/* Team 1: Name + Score (LEFT) */}
            <div className="min-w-0">
              <h2 className="text-[#111] text-[11px] md:text-[13px] font-semibold whitespace-normal break-words leading-snug">
                {teams?.[0]?.school_name}
              </h2>

              {!isHidden && (
                <div className="mt-1">
                  {teams?.[0]?.full_score ? (
                    <p className="text-[#111] text-[14px] md:text-[18px] font-extrabold tracking-wide">
                      {teams[0].full_score}
                    </p>
                  ) : (
                    <div className="flex flex-wrap items-end gap-1 md:gap-2">
                      <p className="text-[#111] text-[16px] md:text-[20px] font-extrabold tracking-wide">
                        {teams?.[0]?.score}/{teams?.[0]?.wicket}
                      </p>
                      <span className="text-[11px] md:text-[13px] font-medium text-[#888]">
                        ({teams?.[0]?.overs})
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Team 1 Logo (RESPONSIVE SIZE) */}
            <div className="flex justify-center">
              <div className="bg-white h-[50px] w-[50px] md:h-[78px] md:w-[78px] shadow-md rounded-full overflow-hidden flex items-center justify-center border border-[#E5E5E5]">
                <img
                  src={
                    teams?.[0]?.school_logo
                      ? teams[0].school_logo.startsWith("http")
                        ? teams[0].school_logo
                        : `${apiUrl}${imagePath}${teams[0].school_logo}`
                      : ""
                  }
                  alt=""
                  className="rounded-full h-full w-full object-contain p-1 md:p-2"
                />
              </div>
            </div>

            {/* VS (RESPONSIVE WIDTH) */}
            <div className="flex justify-center">
              <span className="w-[20px] md:w-[46px] text-center text-[#B82222] font-extrabold text-[12px] md:text-[16px] tracking-widest">
                VS
              </span>
            </div>

            {/* Team 2 Logo (RESPONSIVE SIZE) */}
            <div className="flex justify-center">
              <div className="bg-white h-[50px] w-[50px] md:h-[78px] md:w-[78px] shadow-md rounded-full overflow-hidden flex items-center justify-center border border-[#E5E5E5]">
                <img
                  src={
                    teams?.[1]?.school_logo
                      ? teams[1].school_logo.startsWith("http")
                        ? teams[1].school_logo
                        : `${apiUrl}${imagePath1}${teams[1].school_logo}`
                      : ""
                  }
                  alt=""
                  className="rounded-full h-full w-full object-contain p-1 md:p-2"
                />
              </div>
            </div>

            {/* Team 2: Name + Score (RIGHT) */}
            <div className="min-w-0 text-right">
              <h2 className="text-[#111] text-[11px] md:text-[13px] font-semibold whitespace-normal break-words leading-snug">
                {teams?.[1]?.school_name}
              </h2>

              {!isHidden && (
                <div className="mt-1">
                  {teams?.[1]?.full_score ? (
                    <p className="text-[#111] text-[14px] md:text-[18px] font-extrabold tracking-wide">
                      {teams[1].full_score}
                    </p>
                  ) : (
                    <div className="flex flex-wrap items-end justify-end gap-1 md:gap-2">
                      <p className="text-[#111] text-[16px] md:text-[20px] font-extrabold tracking-wide">
                        {teams?.[1]?.score}/{teams?.[1]?.wicket}
                      </p>
                      <span className="text-[11px] md:text-[13px] font-medium text-[#888]">
                        ({teams?.[1]?.overs})
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>


        {/* Ground */}
        <div className="flex gap-[6px] text-[13px] justify-center tracking-[0.2px] text-[#444]">
          <img src={playground_icon} alt="" className="h-[16px] w-[18px] opacity-80" />
          <p className="whitespace-normal break-words text-center">{playground}</p>
        </div>
      </div>

      {/* Bottom */}
      <div className={`${viewMatchSummaryClassName} rounded-b-[16px] font-semibold tracking-wide`}>
        <h4>{summaryText}</h4>
      </div>
    </div>
  );

  return (
    <>
      {status === "Recent" || status === "Upcoming" || status === "Live" ? (
        <Link className="w-full" to={handleClick} style={{ textDecoration: "none" }}>
          {cardContent}
        </Link>
      ) : (
        cardContent
      )}
    </>
  );
}

export default MatchCard;
